import { useState, useEffect } from 'react';
import { ChannelLayout, Channel } from 'core/models/channel';

export function useChannelFromTag(tag: string | undefined, channelLayout: ChannelLayout | undefined): Channel | undefined {
    const [channel, setChannel] = useState<Channel>();

    useEffect(() => {
        if (!tag) return;

        const channel = channelLayout?.microphones.get(tag);
        if (!channel) return;

        setChannel(channel);
    }, [tag, channelLayout]);

    return channel;
}
